import { useCallback, useEffect, useRef, useState } from 'react'
import { useImmer } from 'use-immer'
import { useDispatch, useSelector } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
//
import {
  selectOfficialOrigin,
  selectOfficialOriginList,
  // selectPreviewOrigin,
  selectTagList,
  // selectProducerList,
  selectEnableShare,
} from 'redux/selector/app'
// import { selectUserInfo } from "redux/selector/user";
//
import { FALSE, TRUE } from 'constant/common'
import {
  fetchVideoList,
  fetchActorInfoList,
  fetchAddLikeList,
  fetchRemoveLikeList,
  fetchAddCollectList,
  fetchRemoveCollectList,
} from 'api'
import { reportVideoClick } from 'hooks/useAnalytics'

// import AmountFormat from 'utils/amountFormat'
// import overwriteViewCount from "utils/overwriteViewCount";
// import { timeFormat } from "utils/timeFormat";
// import { videoPaymentType } from "constant/video";

import Carousel from './component/Carousel'
import RelativeActorVideo from './component/RelativeActorVideo'
import RelativeCategoryVideo from './component/RelativeCategoryVideo'

import likeIcon from './animated-icon/like_outline.json'
import saveIcon from './animated-icon/save_outline.json'

import {
  Wrapper,
  Content,
  VideoInfo,
  Text,
  Info,
  InfoItem,
  ShortcutArea,
  Shortcut,
  ShortcutIcon,
  OriginList,
  OriginItem,
  ShortcutOrigin,
  StyledVideoPlayer,
  StyledAnimatedIcon,
  ShortcutIconDropDown,
  TagArea,
  TagItem,
  TagAreaInner,
  VipLink,
  PaidLink,
  ActorTag,
  InfoItemLink,
} from './Styled'
import { RESET_FAVOURITE } from 'redux/constant/favourite'
import { RESET_COLLECTION } from 'redux/constant/collection'
import actions from 'redux/action'
import { shareVideoActions } from 'redux/slice/shareVideo'
import { selectShareVideoData } from 'redux/selector/shareVideo'
import useAlertWorksActionResult from 'hooks/useAlertWorksActionResult'
import { useMutex } from 'hooks/useMutex'
import { selectUserInfo } from 'redux/selector/user'
import { videoPaymentType } from 'constant/video'
import { useOpenPurchaseVideoModal } from 'hooks/useOpenPurchaseVideoModel'
import useOpenModal from './hooks/useOpenModal'
import { useSharedCache } from 'hooks/useDirtyWorkData'
import { useNavigateTo, useParamsOfPage } from 'hooks/useNavigateTo'
import { usePageActivated } from 'app-layered-layout/usePageActivated'
import { useAppNavigate } from 'app-layered-layout/useAppNavigate'
import { useToastAlert } from 'hooks/useToastAlert'
import { catchPromiseCancel } from 'utils/catchPromiseCancel'
import usePartVideo from 'hooks/usePartVideo'
import { getDebugInfo } from 'utils/debugUtil'
import useHintModal from 'hooks/useHintModal'
import ShareVideoModal from 'component/ShareVideoModal'
import useOpenShareModal from 'page/SharePage/hooks/useOpenShareModal'

export default function ViewVideo() {
  const { addDirtyData, useMappedData } = useSharedCache()

  const pageActivated = usePageActivated()
  const [everActivated, setEverActivated] = useState(false)
  useEffect(() => {
    if (pageActivated) setEverActivated(true)
  }, [pageActivated])
  const videoInfo_ = useParamsOfPage('watch')
  const navigate = useAppNavigate()
  const { navigateToViewMore, navigateToActor, navigateToProducer, navigateToViewVideo } = useNavigateTo()
  const openShareModal = useOpenShareModal()

  const [videoInfo] = useMappedData('video', [videoInfo_])

  const dispatch = useDispatch()
  const { checkVideo } = usePartVideo()

  const [state, updateState] = useImmer({
    actorInfo: {} as Record<any, any>,
    producerVideoCount: null as number | null,
    originalVideo: null as any,
  })

  const [isPlayingH265, setIsPlayingH265] = useState(false)

  // 檢查是否啟用 H265 顯示 debug flag
  const debugFlags = getDebugInfo()
  const showH265Indicator = debugFlags.includes('SHOW_VIDEO_IS_H265')

  const [originListVisible, setOriginListVisible] = useState<boolean>()

  const onToggleOriginList = useCallback((v: boolean) => {
    setOriginListVisible(v)
  }, [])

  const currentOfficialOrigin = useSelector(selectOfficialOrigin)
  const officialOriginList = useSelector(selectOfficialOriginList)

  const selectedOfficialOriginName =
    officialOriginList.find((i: any) => i.domain === currentOfficialOrigin)?.name ?? '高速线路1'

  const userInfo = useSelector(selectUserInfo)
  const tagList = useSelector(selectTagList)?.data

  const openPurchaseVideoModal = useOpenPurchaseVideoModal({ videoInfo })
  const { openEnableVipModal } = useOpenModal({ videoInfo })
  const {
    id,
    video_code,
    show_video_code,
    title,
    // video_length,
    // view_count,
    tag_ids,
    // producer_id,
    actor_ids,
    posterImg,
    producer_name,
    producer_icon,
    producer_id,
    // view_count,
    payment_type,
    product_coin,
    buy_video,
  } = videoInfo

  const validDisplayActorIds = actor_ids?.filter((i: any) => state.actorInfo[i] != null) ?? []

  const isVIP = userInfo.is_vip === TRUE
  const isBuyVideo = buy_video === TRUE

  /** 影片類型為金幣, 且用戶沒有買過影片 */
  const isCoinVideoNeverBuy = payment_type === videoPaymentType.COIN && !isBuyVideo

  /** 影片類型為VIP, 但用戶非VIP */
  const isVipVideoNotVip = payment_type === videoPaymentType.VIP && !isVIP

  /** 是否顯示番號 */
  const isDisplayVideoCode = show_video_code === TRUE

  // N1-5268：detail API 是否已回填（列表資料無 video_code / actor_ids，須等 detail 才有完整維度）
  const [detailSettledId, setDetailSettledId] = useState<string | null>(null)

  useEffect(() => {
    if (!pageActivated) return

    const controller = new AbortController()
    const signal = controller.signal

    fetchVideoList({
      // WARN: force cast string to number because js do not support int64.
      id: videoInfo_?.id as unknown as number,
      detail: TRUE,
      current: 1,
      pageSize: 1,
      signal,
    })
      .then((response: any) => {
        const data = response?.data[0]

        const producer_video_count = data?.producer_video_count
        const formatProducerVideoCount = producer_video_count ? producer_video_count : 0

        addDirtyData('video', response?.data)

        updateState((draft) => {
          draft.producerVideoCount = formatProducerVideoCount
        })

        setDetailSettledId(videoInfo_?.id ?? null)
      })
      .catch((err: any) => {
        // 非取消的失敗也視為就緒，避免核心點擊事件永久漏報（缺漏 video_code / 演員維度略過）
        if (!signal.aborted) setDetailSettledId(videoInfo_?.id ?? null)
        catchPromiseCancel(err)
      })

    return () => {
      controller.abort()
    }
  }, [pageActivated, videoInfo_, updateState, addDirtyData])

  const actorIds = videoInfo?.actor_ids?.join(',') ?? ''
  const actorIdLength = videoInfo?.actor_ids?.length ?? 0

  // N1-5268：演員名單抓取是否已就緒（綁定當前 actorIds，避免 ids 變動後沿用舊 settled）
  const [actorFetchedIds, setActorFetchedIds] = useState<string | null>(null)

  useEffect(() => {
    if (actorIds === '') {
      // 無演員即視為就緒（此時該筆已是當前 id 的回填資料）
      setActorFetchedIds('')
      return
    }
    const controller = new AbortController()
    const { signal } = controller
    /** 獲取演員資訊 */
    fetchActorInfoList({
      signal,
      ids: actorIds,
      pageSize: actorIdLength,
    })
      .then((response: any) => {
        // 舊請求延遲 resolve（actorIds 已變更/元件已卸載）時不寫入 stale 狀態
        if (signal.aborted) return
        const info: Record<any, any> = {}
        response?.data?.forEach((item: any, i: number) => {
          info[item?.id] = {
            id: item?.id,
            name: item?.name,
            icon_path: item?.icon_path,
          }
        })

        updateState((draft) => void (draft.actorInfo = info))
        setActorFetchedIds(actorIds)
      })
      .catch((err: any) => {
        // 非取消的失敗也視為就緒，避免核心點擊事件永久漏報（缺漏演員名稱略過）
        if (!signal.aborted) setActorFetchedIds(actorIds)
        catchPromiseCancel(err)
      })
    return () => {
      controller.abort()
    }
  }, [actorIdLength, actorIds, updateState])

  // N1-5268：影片點擊上報（進入播放頁、detail 回填 + 演員名單就緒後，每支影片只報一次）
  const reportedIdRef = useRef<string | null>(null)
  const actorSettled = actorFetchedIds === actorIds
  // 列表資料只有 id/title（無 video_code、無 actor_ids），只看 core 會在 detail 回來前就送出並鎖死，
  // 造成「每支影片的第一次點擊」缺番號與 dimension8；故一律等 detail settled（失敗/逾時亦視為 settled）
  const detailSettled = detailSettledId != null && detailSettledId === videoInfo?.id

  useEffect(() => {
    const coreReady = Boolean(videoInfo?.id && videoInfo?.title)
    // 不因標籤資料未齊全而阻塞核心事件：detail + actor settled 即上報一次，dimension9 為 best-effort
    // （tagList 未就緒的罕見情況下 dimension9 可能缺，屬與演員名稱相同等級的取捨，不漏報核心事件）
    if (!coreReady || !detailSettled || !actorSettled || reportedIdRef.current === videoInfo.id) return

    const actorNames = (videoInfo?.actor_ids ?? []).map((i: string) => state.actorInfo[i]?.name)
    const tagNames = videoInfo?.tag_names?.length
      ? videoInfo.tag_names
      : (videoInfo?.tag_ids ?? []).map(
          (tagId: string) => tagList?.filter((t: { id?: string; name?: string }) => t.id === tagId)?.[0]?.name
        )

    reportVideoClick({
      type: videoInfo.type,
      videoCode: videoInfo.video_code,
      title: videoInfo.title,
      actorNames,
      tagNames,
    })
    reportedIdRef.current = videoInfo.id
  }, [videoInfo, detailSettled, actorSettled, state.actorInfo, tagList])

  const ong_video = videoInfo?.ong_video

  useEffect(() => {
    if (!ong_video) return
    const controller = new AbortController()
    const { signal } = controller
    fetchVideoList({
      signal,
      video_code: ong_video,
    })
      .then((response: any) => {
        if (response?.data[0]) {
          updateState((draft) => void (draft.originalVideo = response?.data[0]))
        }
      })
      .catch(catchPromiseCancel)
    return () => {
      controller.abort()
    }
  }, [ong_video, updateState])

  const { toast } = useToastAlert()
  const enableShare = useSelector(selectEnableShare)
  const { shareUrl, fallbackToShare } = useSelector(selectShareVideoData)
  const { openHintModal } = useHintModal()
  const videoContainerRef = useRef<HTMLDivElement>(null)
  const wasPlayingBeforeModal = useRef(false)
  // 標記「這次的分享結果是不是本頁自己發起的」。分享狀態是全域單例，
  // 瀑布流成為第二個 consumer 後，若不判斷 owner，本頁會誤消費別處觸發的分享結果。
  const didInitiateShareRef = useRef(false)

  // modal 的 props 只在開啟當下讀取，放進 ref 以免成為 effect 依賴。
  // 若讓 title/封面成為依賴，它們在 modal 開啟期間變動會使 effect 重跑，
  // 屆時影片已被暫停，wasPlayingBeforeModal 會被覆寫成 false，關閉後就不會恢復播放。
  const shareModalPropsRef = useRef({ title: videoInfo?.title, posterImg, coverphoto: videoInfo?.coverphoto_h })
  shareModalPropsRef.current = { title: videoInfo?.title, posterImg, coverphoto: videoInfo?.coverphoto_h }

  // 成功路徑：開啟影片分享 modal。
  // 不能在這裡 clearShareData —— modal 自己從 Redux 讀 shareUrl，關閉時才清除。
  useEffect(() => {
    if (shareUrl) {
      // 非作用中就不消費：effect 宣告順序在「離開本頁即放棄」那個 effect 之前，
      // 若 pageActivated 轉 false 與 shareUrl 落地發生在同一次 commit，
      // 這裡會先跑並把 owner 消費掉、在新頁面上彈出背景頁的分享卡。
      // 保留 owner 不動，交由後面的清理 effect 放棄這次分享。
      if (!pageActivated) return
      if (!didInitiateShareRef.current) return
      didInitiateShareRef.current = false
      const video = videoContainerRef.current?.querySelector('video')
      wasPlayingBeforeModal.current = !!video && !video.paused
      video?.pause()
      openHintModal({ children: ShareVideoModal, props: shareModalPropsRef.current })
    } else if (wasPlayingBeforeModal.current) {
      // 頁面堆疊會保留非作用中的影片頁，若不判斷會讓背景頁面自己播起來。
      // 但非活躍只是「還不能播」，不是「不用播」——旗標必須留到真的補播為止。
      // 原本在判斷之前就無條件清掉，導致 pageActivated 短暫為 false 時
      // play() 被跳過、旗標卻已清空，之後永不恢復，影片永久停在暫停。
      // deps 含 pageActivated，保留旗標直接 return 即可讓它在重新活躍時補播。
      if (!pageActivated) return
      wasPlayingBeforeModal.current = false
      videoContainerRef.current?.querySelector('video')?.play()
    }
  }, [shareUrl, openHintModal, pageActivated])

  // 離開本頁時放棄仍在途中的分享（對稱於 Waterfall 的同名 effect）。
  //
  // 若不清：本頁前進到別頁後，若在該頁又發起一次分享，saga 的 takeLatest
  // 會取消本頁這次請求，成功與降級（fallbackToShare）兩個 effect 都不會觸發，
  // didInitiateShareRef 永遠卡在 true，直到下次全域 shareUrl 變動時被本頁
  // （此時已在背景）誤判為自己的結果，搶開全域 modal 槽。
  //
  // 只清自己的 ref，不 dispatch clearShareData——此時別頁可能已發起自己的
  // 分享，在背景清全域分享狀態會把對方的結果殺掉。
  useEffect(() => {
    if (pageActivated) return
    if (!didInitiateShareRef.current) return // 已被成功/降級路徑消費（modal 已開或已 fallback）：無需再清
    didInitiateShareRef.current = false
  }, [pageActivated])

  useEffect(() => {
    if (fallbackToShare) {
      if (!didInitiateShareRef.current) return
      didInitiateShareRef.current = false
      // 降級：開全屏分享彈窗，不 push /share（堆疊多頁 /watch 時跳路由會導致返回卡在 /share）
      videoContainerRef.current?.querySelector('video')?.pause()
      openShareModal()
      dispatch(shareVideoActions.clearShareData())
    }
  }, [fallbackToShare, openShareModal, dispatch])

  const handleOriginalVideoClick = useCallback(() => {
    if (state.originalVideo) {
      navigateToViewVideo(state.originalVideo)
    } else {
      toast('无法取得原片连结')
    }
  }, [navigateToViewVideo, state.originalVideo, toast])

  const alerts = useAlertWorksActionResult()
  const { wrap: wrapAddLike } = useMutex()
  const { wrap: wrapShare } = useMutex()

  const handelAddLikeList = wrapAddLike(async () => {
    if (videoInfo?.like === TRUE) {
      // WARN: force cast string to number because js do not support int64.
      await fetchRemoveLikeList({ video_id: videoInfo?.id as unknown as number })
    } else {
      await fetchAddLikeList({ video_id: videoInfo?.id })
    }

    const latestData = (
      await fetchVideoList({
        // WARN: force cast string to number because js do not support int64.
        id: videoInfo?.id as unknown as number,
        detail: TRUE,
      })
    ).data

    addDirtyData('video', latestData)

    dispatch({ type: RESET_FAVOURITE })
  })

  const { wrap: wrapAddCollection } = useMutex()
  const handelAddCollectList = wrapAddCollection(async () => {
    if (videoInfo?.favorite === TRUE) {
      // WARN: force cast string to number because js do not support int64.
      await fetchRemoveCollectList({ video_id: videoInfo?.id as unknown as number })
    } else {
      await fetchAddCollectList({ video_id: videoInfo?.id })
    }

    const latestData = (
      await fetchVideoList({
        // WARN: force cast string to number because js do not support int64.
        id: videoInfo?.id as unknown as number,
        detail: TRUE,
      })
    ).data

    addDirtyData('video', latestData)

    dispatch({ type: RESET_COLLECTION })
    if (videoInfo?.favorite === FALSE) {
      alerts.alertSaved()
    }
  })

  const handleShare = wrapShare(() => {
    if (!enableShare) {
      videoContainerRef.current?.querySelector('video')?.pause()
      openShareModal()
      return Promise.resolve()
    }
    didInitiateShareRef.current = true
    dispatch(shareVideoActions.fetchShareVideo(id))
    return Promise.resolve()
  })

  const openTag = (tagInfo: any) => {
    const { id, name } = tagInfo

    const params = {
      tag_ids: id,
    }

    navigateToViewMore({
      params,
      headerTitle: name,
      type: 'video',
    })
  }

  function handleActorClick(actor: any) {
    navigateToActor({
      actorId: actor.id,
    })
  }

  function handleProducerClick() {
    navigateToProducer({
      producerId: producer_id,
      producerImage: producer_icon,
      producerName: producer_name,
    })
  }

  const startTime = useRef<number | null>(null)

  const onPlay = useCallback(() => {
    startTime.current = Date.now()
  }, [])

  const endPlayTime = useCallback((end: number) => {
    if (startTime.current != null) {
      startTime.current = null
    }
  }, [])

  const onPause = useCallback(() => {
    endPlayTime(Date.now())
  }, [endPlayTime])

  const onEnded = useCallback(() => {
    endPlayTime(Date.now())
  }, [endPlayTime])

  const handleH265StatusChange = useCallback((isH265: boolean) => {
    setIsPlayingH265(isH265)
  }, [])

  useEffect(() => {
    if (!pageActivated) {
      endPlayTime(Date.now())
      const video = videoContainerRef.current?.querySelector('video')
      if (video && !video.paused) {
        video.pause()
      }
    }
  }, [endPlayTime, pageActivated])

  const LEAVE_TIME = 2000
  const leaveTimer = useRef<ReturnType<typeof setTimeout> | null>(null)
  useEffect(() => {
    clearTimeout(leaveTimer.current as any)

    return () => {
      const end = Date.now()
      leaveTimer.current = setTimeout(() => {
        endPlayTime(end)
      }, LEAVE_TIME)
    }
  })

  const videoIdRef = useRef<any>(null)
  useEffect(() => {
    if (id === videoIdRef.current) {
      return
    }
    videoIdRef.current = id
    checkVideo(id)
    return () => {
      videoIdRef.current = null
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Wrapper>
      {/* <IconBack onClick={() => closePageModal(uuid)} /> */}

      <Content>
        <div ref={videoContainerRef}>
          {everActivated && (
            <StyledVideoPlayer
              videoInfo={videoInfo}
              poster={posterImg}
              skipBigPlayIcon
              onPlay={onPlay}
              onPause={onPause}
              onEnded={onEnded}
              onH265StatusChange={handleH265StatusChange}
              onBack={() => {
                navigate(-1)
              }}
            />
          )}
        </div>

        {isVipVideoNotVip && <VipLink onClick={openEnableVipModal}>升级VIP会员立享全站高清无限看</VipLink>}
        {isCoinVideoNeverBuy && <PaidLink onClick={openPurchaseVideoModal}>支付{product_coin}金币解锁完整版</PaidLink>}
        <VideoInfo>
          <Text>{title}</Text>
          <Info>
            {producer_name && (
              <InfoItem>
                片商：<InfoItemLink onClick={handleProducerClick}>{producer_name}</InfoItemLink>
              </InfoItem>
            )}
            {isDisplayVideoCode && <InfoItem>番号：{video_code}</InfoItem>}
            {validDisplayActorIds.length > 0 && (
              <InfoItem>
                演员：
                {validDisplayActorIds.map((i: any) => (
                  <ActorTag key={i} onClick={() => handleActorClick(state.actorInfo[i])}>
                    {state.actorInfo[i].name}
                  </ActorTag>
                ))}
              </InfoItem>
            )}
            {showH265Indicator && <InfoItem>{isPlayingH265 ? 'H.265' : 'H.264'}</InfoItem>}
            {ong_video && (
              <InfoItem>
                原片：
                <InfoItemLink onClick={handleOriginalVideoClick}>链結</InfoItemLink>
              </InfoItem>
            )}
            {/* <InfoItem>觀看人數：{
              view_count > 10000
                ? (view_count / 1000).toFixed(1).replace(/\.0/, '') + 'k'
                : view_count
            }</InfoItem> */}
          </Info>

          <ShortcutArea>
            <ShortcutOrigin onClick={() => onToggleOriginList(!originListVisible)}>
              <ShortcutIcon name="globe.svg" />
              {selectedOfficialOriginName}
              <ShortcutIconDropDown name="arrow-down.svg" />
            </ShortcutOrigin>
            <Shortcut onClick={handelAddLikeList}>
              <StyledAnimatedIcon animationData={likeIcon} active={videoInfo.like === TRUE} />
              喜欢
            </Shortcut>
            <Shortcut onClick={handelAddCollectList}>
              <StyledAnimatedIcon animationData={saveIcon} active={videoInfo.favorite === TRUE} />
              收藏
            </Shortcut>
            <Shortcut onClick={handleShare}>
              <ShortcutIcon name="share.svg" />
              分享
            </Shortcut>
          </ShortcutArea>
          {originListVisible ? (
            <OriginList>
              {officialOriginList.map((item: any) => (
                <OriginItem
                  onClick={() => {
                    if (currentOfficialOrigin !== item.domain) {
                      dispatch(actions.updateOfficialOrigin(item.domain))
                    }
                  }}
                  className={currentOfficialOrigin !== item.domain ? '' : 'active'}
                  key={item.domain}
                >
                  {item.name}
                </OriginItem>
              ))}
            </OriginList>
          ) : null}

          {/** 影片標籤 */}
          {!isEmpty(tag_ids) && (
            <TagArea>
              <TagAreaInner>
                {tag_ids
                  ?.map((tagId: any, i: number) => {
                    const info = tagList?.filter((tagInfo: any) => tagInfo.id === tagId)?.[0]

                    if (info == null) {
                      return null
                    }

                    return (
                      <TagItem key={i} onClick={() => openTag(info)}>
                        {info.name}
                      </TagItem>
                    )
                  })
                  .filter((i: any) => i)}
              </TagAreaInner>
            </TagArea>
          )}

          {everActivated && <Carousel />}
        </VideoInfo>

        {everActivated && <RelativeActorVideo videoInfo={videoInfo} />}

        {everActivated && <RelativeCategoryVideo videoInfo={videoInfo} />}
      </Content>
    </Wrapper>
  )
}
